
import React, { Component } from 'react';
import { Avatar, Dropdown, Space, Divider } from 'antd';
import { withTranslation } from 'react-i18next';
import { TranslationOutlined } from '@ant-design/icons';

class SelectLanguage extends Component {
    render() {
        const { i18n, t } = this.props;
        const currentLanguage = i18n?.language;

        const languages = [
            { key: 'en', code: 'GB', label: 'English' },
            { key: 'th', code: 'TH', label: 'ภาษาไทย' },
            { key: 'lao', code: 'LA', label: 'ພາສາລາວ' },
        ];

        const currentConfig = languages.find(lang => lang.key === currentLanguage) || languages[0];

        // 1. สร้าง items สำหรับ Menu
        const items = languages.map((lang) => ({
            key: lang?.key,
            disabled: currentLanguage === lang?.key,
            label: (
                <Space>
                    <Avatar size={22} src={`https://flagsapi.com/${lang?.code}/flat/64.png`} />
                    <span style={{ color: currentLanguage === lang?.key ? '#1890ff' : 'inherit' }}>
                        {lang?.label}
                    </span>
                </Space>
            ),
            onClick: () => i18n.changeLanguage(lang?.key),
        }));

        return (
            <Space wrap>
                <Dropdown
                    menu={{ items }}
                    arrow={true}
                    placement="bottomRight"
                    trigger={['click']}
                    dropdownRender={(menu) => (
                        <div style={{
                            backgroundColor: '#fff',
                            borderRadius: '8px',
                            boxShadow: 'rgb(0 0 0) 0px 3px 6px -4px, rgb(0 0 0 / 17%) 0px 6px 16px 0px'
                        }}>
                            <div style={{ padding: '10px 15px', fontWeight: 'bold' }}>
                                <TranslationOutlined style={{ marginRight: 3 }} /> {" "}  {t("Select language")}
                            </div>
                            <Divider style={{ margin: 0 }} />
                            {/* สำคัญ: ต้อง Render menu เดิมเพื่อให้ onClick ทำงาน */}
                            {React.cloneElement(menu, {
                                style: { boxShadow: 'none' }
                            })}
                        </div>
                    )}
                >
                    <strong
                        style={{ display: 'flex', alignItems: 'center', cursor: "pointer" }}
                    >
                        <Avatar
                            shape="circle"
                            size={24}
                            src={`https://flagsapi.com/${currentConfig?.code}/flat/64.png`}
                        />
                    </strong>
                </Dropdown>
            </Space>
        );
    }
}

export default withTranslation()(SelectLanguage);